import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox'
import { cva, type VariantProps } from 'class-variance-authority'
import { CheckIcon } from 'lucide-react'

import { cn } from '@/shared/lib/cn'

/** Размер `lg` рассчитан на карточку-вариант: там отметка — главный ориентир, а не спутник строки. */
const checkboxVariants = cva(
  'peer border-input data-[checked]:bg-primary data-[checked]:text-primary-foreground data-[checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive shrink-0 border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      size: {
        default: 'size-4 rounded-[4px]',
        lg: 'size-5 rounded-[6px]',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

function Checkbox({ className, size, ...props }: CheckboxPrimitive.Root.Props & VariantProps<typeof checkboxVariants>) {
  return (
    <CheckboxPrimitive.Root data-slot="checkbox" className={cn(checkboxVariants({ size }), className)} {...props}>
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="size-full flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className={size === 'lg' ? 'size-4' : 'size-3.5'} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
